import { pushToDataLayer } from '../gaTracker';
import { getSectionCategorySubCat } from '../getSectionCategorySubCat';
export var ecommClick = function ecommClick(product) {
  var categories = getSectionCategorySubCat(product === null || product === void 0 ? void 0 : product.detailLink);
  var ecommerceObj = {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: 'PLP'
        },
        products: [{
          name: product === null || product === void 0 ? void 0 : product.name,
          id: product === null || product === void 0 ? void 0 : product.id,
          price: product === null || product === void 0 ? void 0 : product.price,
          section: categories[0] || '',
          category: categories[1] || '',
          'dimension1': categories[2] || '',
          'dimension2': categories[3] || '',
          'dimension3': 'In stock',
          'dimension4': (product === null || product === void 0 ? void 0 : product.collection) || '',
          'dimension5': (product === null || product === void 0 ? void 0 : product.catalog) || '',
          'dimension6': 'Regular Price',
          'variant': (product === null || product === void 0 ? void 0 : product.variants) || '',
          'position': 1
        }]
      }
    }
  };
  pushToDataLayer(ecommerceObj);
};